class BuyController
{
    constructor ( authService, $state, $cookies, $q, GlobalRedirects, toaster )
    {
        'ngInject';
        Object.assign( this, { authService, $state, $cookies, $q, GlobalRedirects, toaster } )
        this.registration = {};
        this.errors = [];
        this.loading = false;
    }

    submit ()
    {
        if ( this.registration.$invalid )
        {
            this.toaster.pop( 'error', "Registration failed", 'Some fields are invalid', 4000, 'trustedHtml' );
            const elements = document.querySelectorAll( '#buy-the-course .ng-untouched' )
            if ( !elements || !elements.length )
            {
                return
            }
            const $elements = $( elements )
            $elements.removeClass( 'ng-untouched' )
            $elements.addClass( 'ng-touched' )
            return
        }
        this.errors = [];
        this.loading = true;
        this.authService.register( {
            user: {
                'firstName': this.registration.firstName,
                'lastName': this.registration.lastName,
                'email': this.registration.email,
                'password': this.registration.password,
                'passwordConfirmation': this.registration.passwordConfirmation
            }
        } )
            .then( data =>
            {
                if ( data.errors )
                {
                    this.errors = data.errors;
                    this.loading = false;
                }
                else
                {
                    this.authService
                        .login( {
                            user: {
                                'email': this.registration.email,
                                'password': this.registration.password,
                            }
                        } )
                        .then( data =>
                        {
                            this.$state.isJustRegistered = true
                            this.$state.userFirstName = this.registration.firstName
                            this.$state.go( this.GlobalRedirects.AFTER_LOGIN )
                        } )
                }
            } )
            .catch( error =>
            {
                this.loading = false;
                console.log( error );
            } );
    }

}

export default BuyController;



// WEBPACK FOOTER //
// ./client/app/modules/site/buy/buy.controller.js